import type { ReactNode } from 'react';

interface BotaoPrincipalProps {
  children: ReactNode;
  aoTocar: () => void;
  carregando?: boolean;
  /** Aparência de desabilitado, mas ainda tocável (para avisar o que falta). */
  travado?: boolean;
}

// Botão principal: 52 px, largura total, azul primário.
export default function BotaoPrincipal({
  children,
  aoTocar,
  carregando = false,
  travado = false,
}: BotaoPrincipalProps) {
  return (
    <button
      type="button"
      onClick={aoTocar}
      aria-disabled={travado || carregando}
      className={`aperta flex h-[52px] w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl px-5 text-[16px] font-bold text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 ${
        travado ? 'bg-secondary-300 hover:bg-secondary-300' : 'bg-primary-500 hover:bg-primary-600'
      }`}
    >
      {carregando && (
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-loader-4-line animate-spin" aria-hidden />
        </span>
      )}
      {children}
    </button>
  );
}